import { render, staticRenderFns } from "./Egifts.vue?vue&type=template&id=5fb0f118&"
import script from "./Egifts.vue?vue&type=script&lang=js&"
export * from "./Egifts.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports